import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/investing-account")({
  beforeLoad: () => {
    // GLI-1882: the investing account page is for debugging only, so deployed
    // builds return not found and local dev keeps it.
    if (!(import.meta.env.DEV || import.meta.env.MODE === "test")) {
      throw notFound();
    }
  },
  loader: ({ context }) => {
    void import("~/features/investing-account/investing-account-route").then(
      ({ preloadInvestingAccountRoute }) => {
        void preloadInvestingAccountRoute(context);
      },
    );
  },
});
